export default __webpack_public_path__ + "static/media/headerTitleQh.bf43af38.jpg";